import { Component, Input, OnInit } from '@angular/core';
import { RowBlockSimple } from 'src/app/shared/models/node';

@Component({
  selector: 'app-multiple-items',
  templateUrl: './multiple-items.component.html',
  styleUrls: ['./multiple-items.component.scss']
})
export class MultipleItemsComponent implements OnInit {

  @Input() block: RowBlockSimple = {} as RowBlockSimple;
  @Input() bundle: string = '';
  @Input() positionRowIdx: number = 0;

  constructor() { }

  ngOnInit(): void { this.goToCarousel(); }

  goToCarousel(): boolean {
    switch (this.bundle) {
      case 'blocco_immagine':
        return true;
      case 'blocco_video':
        return true;
      case 'blocco_numero':
        return true;
      case 'blocco_quote_testimonial':
        return true;
      case 'blocco_visore_hero_1':
        return true;
      case 'blocco_paragrafo_immagine':
        return true;
      default:
        return false;
    }
  }

}
